import { endpoints } from '@gopinhos/shared';
import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../lib/api-client';

export interface FlowchartGraph {
  id: string;
  projectId: string;
  version: number;
  name: string;
  isActive: boolean;
  stages: Array<{
    id: string;
    slug: string;
    name: string;
    color: string;
    position: number;
    isInitial: boolean;
    isTerminal: boolean;
    slaHours: number | null;
  }>;
  transitions: Array<{
    id: string;
    fromStageId: string;
    toStageId: string;
    name: string;
    allowedRole: 'manager' | 'member' | 'viewer';
    requiresNote: boolean;
  }>;
}

export function useFlowchart(flowchartId: string | undefined) {
  return useQuery({
    queryKey: ['flowchart', flowchartId],
    enabled: !!flowchartId,
    queryFn: () =>
      apiClient.request<unknown, never>({
        method: 'GET',
        path: endpoints.flowchart(flowchartId!),
      }) as Promise<{ flowchart: FlowchartGraph; stages: FlowchartGraph['stages']; transitions: FlowchartGraph['transitions'] }>,
  });
}
